import { render, staticRenderFns } from "./EventControlPanelSwappDialog.vue?vue&type=template&id=64e3bf8d&scoped=true&"
import script from "./EventControlPanelSwappDialog.vue?vue&type=script&lang=js&"
export * from "./EventControlPanelSwappDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e3bf8d",
  null
  
)

export default component.exports